module.exports = __webpack_public_path__ + "img/4.b29d6564.jpg";